import { Dispatch } from "redux";
import { camelize } from "../../config/functions";
import {
  getEmployeeAttachments,
  createEmployeeAttachment,
  updateEmployeeAttachment,
  deleteEmployeeAttachment,
  getEmployeeById,
} from "../../services/EmployeeAttachService";
import { EmployeeAttachment } from "../../types/EmployeeAttachment";

// Action types
export enum EmployeeAttachmentActionList {
  ADD_ATTACHMENT = "ADD_ATTACHMENT",
  EDIT_ATTACHMENT = "EDIT_ATTACHMENT",
  FETCH_ATTACHMENTS = "FETCH_ATTACHMENTS",
  FETCH_ATTACHMENT_BY_ID = "FETCH_ATTACHMENT_BY_ID",
  DELETE_ATTACHMENT = "DELETE_ATTACHMENT",
}

// Actions
export interface AddAttachmentAction {
  type: EmployeeAttachmentActionList.ADD_ATTACHMENT;
  data: EmployeeAttachment;
}

export interface EditAttachmentAction {
  type: EmployeeAttachmentActionList.EDIT_ATTACHMENT;
  data: EmployeeAttachment;
  id: number;
}

export interface FetchAttachmentAction {
  type: EmployeeAttachmentActionList.FETCH_ATTACHMENTS;
  data: EmployeeAttachment[];
}

export interface DeleteAttachmentAction {
  type: EmployeeAttachmentActionList.DELETE_ATTACHMENT;
  data: number;
}
export interface FetchAttachmentByIdAction {
  type: EmployeeAttachmentActionList.FETCH_ATTACHMENT_BY_ID;
  data: EmployeeAttachment | null;
}

export type EmployeeAttachmentActions =
  | AddAttachmentAction
  | EditAttachmentAction
  | FetchAttachmentAction
  | FetchAttachmentByIdAction
  | DeleteAttachmentAction;

// Action Creators

export const addAttachmentAction = (formData: FormData) => {
  return async (dispatch: Dispatch) => {
    return createEmployeeAttachment(formData)
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          const rawData = response.data.data;
          let attachment: any = {};
          for (let key in rawData) {
            attachment[camelize(key)] = rawData[key];
          }

          dispatch<AddAttachmentAction>({
            type: EmployeeAttachmentActionList.ADD_ATTACHMENT,
            data: attachment,
          });

          return Promise.resolve(response.data.message ?? "Attachment added");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to add attachment",
        ),
      );
  };
};

export const editAttachmentAction = (id: number, data: EmployeeAttachment) => {
  return async (dispatch: Dispatch) => {
    return updateEmployeeAttachment(id, data)
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          const rawData = response.data.data;
          let attachment: any = {};
          for (let key in rawData) {
            attachment[camelize(key)] = rawData[key];
          }

          dispatch<EditAttachmentAction>({
            type: EmployeeAttachmentActionList.EDIT_ATTACHMENT,
            data: attachment,
            id,
          });

          return Promise.resolve(response.data.message ?? "Attachment updated");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to update attachment",
        ),
      );
  };
};

export const fetchAttachmentsAction = () => {
  return async (dispatch: Dispatch) => {
    const response = await getEmployeeAttachments();
    console.log(response);

    dispatch<FetchAttachmentAction>({
      type: EmployeeAttachmentActionList.FETCH_ATTACHMENTS,
      data: response,
    });
  };
};
// In empAttachAction.ts

export const fetchAttachmentByIdAction = (employeeId: string) => {
  return async (dispatch: Dispatch) => {
    try {
      const rawData = await getEmployeeById(employeeId);

      // camelize keys (same as your other actions)
      // let attachment: any = {};
      // for (let key in rawData) {
      //   attachment[camelize(key)] = rawData[key];
      // }

      dispatch<FetchAttachmentByIdAction>({
        type: EmployeeAttachmentActionList.FETCH_ATTACHMENT_BY_ID,
        data: rawData.data,
      });
    } catch (error: any) {
      // Optionally handle error here
      console.error("Failed to fetch attachment by ID", error);
      dispatch<FetchAttachmentByIdAction>({
        type: EmployeeAttachmentActionList.FETCH_ATTACHMENT_BY_ID,
        data: null,
      });
    }
  };
};

export const deleteAttachmentAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    return deleteEmployeeAttachment(id)
      .then((response) => {
        if (response.status === 200) {
          dispatch<DeleteAttachmentAction>({
            type: EmployeeAttachmentActionList.DELETE_ATTACHMENT,
            data: id,
          });

          return Promise.resolve(response.data.message ?? "Attachment deleted");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to delete attachment",
        ),
      );
  };
};
